import { ProductTileContainer } from "@faire/web-api--source/indigofair/data/ProductTileContainer";
import { ProductTileScreen } from "@faire/web-api--source/indigofair/data/ProductTileScreen";
import { ProductTileScreenContainer } from "@faire/web-api--source/indigofair/data/ProductTileScreenContainer";
import React from "react";

export interface IProductTileClickImpressionContextValue {
  badgeEventTokens: Set<string>;
  context:
    | `${keyof typeof ProductTileContainer}|${string}`
    | keyof typeof ProductTileContainer;
  productTileContainer: ProductTileContainer;
  containerName?: string;
  requestId?: string;
  isNewProductsCategory?: boolean;
  screenContext: `${keyof typeof ProductTileScreen}`;
  containerContext: `${keyof typeof ProductTileScreenContainer}`;
  contextToken: string;
}

export const ProductTileClickImpressionContext =
  React.createContext<IProductTileClickImpressionContextValue>({
    badgeEventTokens: new Set(),
    context: `${ProductTileContainer.PRODUCT_TILE_CONTAINER_UNKNOWN}|`,
    productTileContainer: ProductTileContainer.PRODUCT_TILE_CONTAINER_UNKNOWN,
    screenContext: ProductTileScreen.PRODUCT_TILE_SCREEN_UNKNOWN,
    containerContext:
      ProductTileScreenContainer.PRODUCT_TILE_SCREEN_CONTAINER_UNKNOWN,
    contextToken: "",
  });
ProductTileClickImpressionContext.displayName =
  "ProductTileClickImpressionContext";
